import instance from '../axios';

const API_FOLDER = 'reviews/'

export const getAllReviews = async (rating='', dateFrom='', dateTo='') => {
    const response = await instance.get(API_FOLDER + `get-all?rating=${rating}&dateFrom=${dateFrom}&dateTo=${dateTo}`)
    return response.data
}

export const getBoothReviews = async (id, rating='', dateFrom='', dateTo='') => {
    const response = await instance.get(API_FOLDER + `get-booth?id=${id}&rating=${rating}&dateFrom=${dateFrom}&dateTo=${dateTo}`)
    return response.data
}

export const getSummaryReviews = async (id='', dateFrom='', dateTo='') => {
    const response = await instance.get(API_FOLDER + `get-summary?id=${id}&dateFrom=${dateFrom}&dateTo=${dateTo}`)
    return response.data
}

export const getTransactionsReviewsTotal = async (id='', dateFrom='', dateTo='') => {
    const response = await instance.get(API_FOLDER + `get-transactions-reviews-total?id=${id}&dateFrom=${dateFrom}&dateTo=${dateTo}`)
    return response.data
}

export const getReview = async (id) => {
    const response = await instance.get(API_FOLDER + `get-review?id=${id}`)
    return response.data
}
